import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const CardHolderIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 32 32"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M29.3307 5.33594H1.9974L0.664062 6.66927V24.0026L2.66406 26.0026H27.9974L30.6641 24.0026V6.66927L29.3307 5.33594Z"
        fill={getColor(secondaryColor)}
      />
      <path
        d="M28.3077 4H3.69231C2.71305 4 1.77389 4.35821 1.08145 4.99584C0.38901 5.63346 0 6.49826 0 7.4V23.2667C0 24.1684 0.38901 25.0332 1.08145 25.6708C1.77389 26.3085 2.71305 26.6667 3.69231 26.6667H28.3077C29.287 26.6667 30.2261 26.3085 30.9185 25.6708C31.611 25.0332 32 24.1684 32 23.2667V7.4C32 6.49826 31.611 5.63346 30.9185 4.99584C30.2261 4.35821 29.287 4 28.3077 4ZM2.46154 10.8H29.5385V13.0667H20.9231C20.5967 13.0667 20.2836 13.1861 20.0528 13.3986C19.822 13.6112 19.6923 13.8994 19.6923 14.2C19.6923 15.1017 19.3033 15.9665 18.6109 16.6042C17.9184 17.2418 16.9793 17.6 16 17.6C15.0207 17.6 14.0816 17.2418 13.3891 16.6042C12.6967 15.9665 12.3077 15.1017 12.3077 14.2C12.3077 13.8994 12.178 13.6112 11.9472 13.3986C11.7164 13.1861 11.4033 13.0667 11.0769 13.0667H2.46154V10.8ZM3.69231 6.26667H28.3077C28.6341 6.26667 28.9472 6.38607 29.178 6.59861C29.4088 6.81115 29.5385 7.09942 29.5385 7.4V8.53333H2.46154V7.4C2.46154 7.09942 2.59121 6.81115 2.82202 6.59861C3.05284 6.38607 3.36589 6.26667 3.69231 6.26667ZM28.3077 24.4H3.69231C3.36589 24.4 3.05284 24.2806 2.82202 24.0681C2.59121 23.8555 2.46154 23.5672 2.46154 23.2667V15.3333H9.96923C10.2517 16.6143 11.0064 17.766 12.1055 18.5932C13.2046 19.4205 14.5805 19.8723 16 19.8723C17.4195 19.8723 18.7954 19.4205 19.8945 18.5932C20.9936 17.766 21.7483 16.6143 22.0308 15.3333H29.5385V23.2667C29.5385 23.5672 29.4088 23.8555 29.178 24.0681C28.9472 24.2806 28.6341 24.4 28.3077 24.4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CardHolderIconFilled;
